<div class="page-innder-body portlet light ">
  <div class="portlet-body">
    <div class="top-action-bar">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div class="d-flex flex-column align-items-start">
          <div class="d-flex align-items-center gap-2">
            <span class="page-title">{{ 'galleryConsignmentProductsV2.artworksInventory' | transloco }}</span>
            @if (currentConsignedProduct > 0) {
              <span class="count-badge"
              >{{currentConsignedProduct}}</span>
            }
          </div>
          <div class="page-subtitle">{{ 'galleryConsignmentProductsV2.consignedProductsSearchHint' | transloco }}</div>
        </div>
      </div>
    </div>
    <div class="filters-container">
      <div class="d-flex flex-wrap gap-2 align-items-center">
        <div class="form-group flex-fill" style="min-width: 150px;">
          <p-dropdown [options]="artTypes" inputId="artistArtTypes" [filter]="true" [filterBy]="'label'"
            [optionLabel]="'label'" [optionValue]="'value'" name="artistArtTypes" [placeholder]="'galleryConsignmentProductsV2.filterByArtType' | transloco"
            [(ngModel)]="filters.ArtTypeId" [showClear]="true" (onChange)="onArtTypeChanged($event)">
          </p-dropdown>
        </div>
        <div class="form-group flex-fill" style="min-width: 150px;">
          <p-dropdown [options]="productCategories" inputId="productCategory" name="productCategory" [filter]="true"
            [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'" [placeholder]="'galleryConsignmentProductsV2.filterByCategory' | transloco"
            [showClear]="true" [(ngModel)]="filters.ProductCategory" [disabled]="!filters.ArtTypeId"
            (onChange)="onProductCategoriesChange($event)">
          </p-dropdown>
        </div>
        <div class="form-group flex-fill" style="min-width: 150px;">
          <p-dropdown [options]="connectedArtists" [(ngModel)]="artistId" name="selectedArtistId"
            (onChange)="onArtistChanged($event)" [filter]="true" [filterBy]="'label'" [optionLabel]="'label'"
            [optionValue]="'value'" [showClear]="true" appendTo="body" [placeholder]="'galleryConsignmentProductsV2.filterByArtist' | transloco">
          </p-dropdown>
        </div>
        <div class="form-group flex-fill" style="min-width: 150px;">
          <p-dropdown [options]="statusFilterOptions" [filter]="true" [showClear]="true" inputId="statusFilter"
            name="statusFilter" [placeholder]="'galleryConsignmentProductsV2.filterByStatus' | transloco" [(ngModel)]="filters.Status"
          (onChange)="onStatusFilterChange($event)"></p-dropdown>
        </div>
        <div class="form-group flex-fill" style="min-width: 150px;">
          <input type="text" [(ngModel)]="filters.Query" (input)="FilterByProductName()" [placeholder]="'galleryConsignmentProductsV2.filterItems' | transloco"
            class="form-control">
          </div>
          <div class="form-group">
            <p-button type="button" icon="pi pi-times" iconPos="left" [outlined]="true" severity="secondary"
            (click)="clearAllFilters($event)" class="p-button-sm" [label]="'galleryConsignmentProductsV2.clearAll' | transloco"></p-button>
          </div>
        </div>
      </div>
      @if (currentConsignedProduct > 0) {
        <div class="row my-2">
          <div class="col d-flex justify-content-start p-2">
            <div class="d-flex justify-content-end align-items-center flex-wrap ms-1">
              <div class="d-flex align-items-center me-3">
                <p-inputSwitch class="mt-1" [(ngModel)]="filterSquareSyncProducts"
                  (onChange)="getGalleryConsignmentProducts()">
                </p-inputSwitch>
                <span class="ms-2 fw-semibold">{{ 'galleryConsignmentProductsV2.filterSquareupProducts' | transloco }}</span>
              </div>
              <div class="d-flex align-items-center me-3">
                <p-inputSwitch class="mt-1" [(ngModel)]="filterShopifySyncProducts"
                  (onChange)="getGalleryConsignmentProducts()">
                </p-inputSwitch>
                <span class="ms-2 fw-semibold">{{ 'galleryConsignmentProductsV2.filterShopifyProducts' | transloco }}</span>
              </div>
              <div class="d-flex align-items-center me-3">
                <p-inputSwitch class="mt-1" [(ngModel)]="filterWoocommerceSyncProducts"
                  (onChange)="getGalleryConsignmentProducts()">
                </p-inputSwitch>
                <span class="ms-2 fw-semibold">{{ 'galleryConsignmentProductsV2.filterWoocommerceProducts' | transloco }}</span>
              </div>
              <div class="d-flex align-items-center me-3">
                <p-inputSwitch class="mt-1" [(ngModel)]="filterWixSyncProducts"
                  (onChange)="getGalleryConsignmentProducts()">
                </p-inputSwitch>
                <span class="ms-2 fw-semibold">{{ 'galleryConsignmentProductsV2.filterWixProducts' | transloco }}</span>
              </div>
              <div class="d-flex align-items-center">
                <p-inputSwitch class="mt-1" [(ngModel)]="filterSquareSpaceSyncProducts"
                  (onChange)="getGalleryConsignmentProducts()">
                </p-inputSwitch>
                <span class="ms-2 fw-semibold">{{ 'galleryConsignmentProductsV2.filterSquarespaceProducts' | transloco }}</span>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Skeleton Loader -->
      @if (loadingArtistProducts && artistProducts.length == 0) {
        <div class="row my-2">
          @for (placeholder of [1,2,3,4,5,6]; track placeholder) {
            <div class="col-4 mt-3">
              <div class="skeleton-card">
                <div class="skeleton-image"></div>
                <div class="skeleton-details">
                  <div class="skeleton-text skeleton-title"></div>
                  <div class="skeleton-text skeleton-line"></div>
                  <div class="skeleton-text skeleton-line short"></div>
                  <div class="skeleton-text skeleton-line"></div>
                </div>
              </div>
            </div>
          }
          <div class="col-12 text-center text-muted small mt-3">
            <i class="pi pi-spin pi-spinner me-2"></i> {{ 'galleryConsignmentProductsV2.loadingArtworks' | transloco }}
          </div>
        </div>
      }

      @if (galleryProducts.length > 0) {
        <ds-artwork-grid context="gallery-consignment-products" #gcp class="d-block my-2">
          @for (product of galleryProducts; track product) {
            <ds-artwork-card
              [size]="gcp.size"
              [imageUrl]="product.Product.ResizedImageUrl"
              [name]="product.Product?.Name"
              [artist]="product.ArtistName"
              [status]="product.IsProductSold ? ('galleryConsignmentProductsV2.sold' | transloco) : (product.IsConsignedProduct ? ('galleryConsignmentProductsV2.consigned' | transloco) : ('galleryConsignmentProductsV2.available' | transloco))"
              [statusTone]="product.IsProductSold ? 'sold' : (product.IsConsignedProduct ? 'consigned' : 'available')"
              [price]="product.IsProductSold ? product.ProductSoldPrice : (product.IsConsignedProduct ? product.RetailPrice : product.Product?.ArtistRevenue)"
              [priceLabel]="product.IsProductSold ? ('galleryConsignmentProductsV2.soldPrice' | transloco) : (product.IsConsignedProduct ? ('galleryConsignmentProductsV2.retailPrice' | transloco) : ('galleryConsignmentProductsV2.artistRevenue' | transloco))"
              (cardClick)="showProductDetails(product)">
              <div actions class="d-flex justify-content-end w-100">
                <button type="button" class="btn btn-sm btn-link p-0 text-decoration-none"
                  (click)="openProductInformationDailog($event, product.Product.Id)"
                  [pTooltip]="'galleryConsignmentProductsV2.productDetails' | transloco" tooltipPosition="top">
                  <i class="fa fa-info-circle me-1"></i>{{ 'galleryConsignmentProductsV2.productDetails' | transloco }}
                </button>
              </div>
            </ds-artwork-card>
          }
        </ds-artwork-grid>
      }
        @if (galleryProducts.length === 0) {
          <div class="row my-2">
            <div class="col text-center">
              @if (galleryProductsLoaded) {
                {{ 'galleryConsignmentProductsV2.noArtworksInInventory' | transloco }}
              }
              @if (!galleryProductsLoaded) {
                {{ 'galleryConsignmentProductsV2.loadingYourArtworks' | transloco }}
              }
            </div>
          </div>
        }
      </div>
    </div>
    @if (isProductSoldDialogVisible) {
      <app-productsold [isProductSoldDialogVisible]="isProductSoldDialogVisible" [productSoldData]="productSoldData"
        (onCloseDailog)="onCloseProductSoldDailog($event)" (productSold)="onProductSold($event)">
      </app-productsold>
    }
    @if (isReturnToArtistDialogVisible) {
      <p-dialog [header]="'galleryConsignmentProductsV2.returnProductToArtist' | transloco" [(visible)]="isReturnToArtistDialogVisible" [modal]="true"
        [style]="{ 'width': '560px' }">
        <form class="form-horizontal px-2" #returnToArtistForm="ngForm">
          <div class="d-flex mt-4">
            <img
              [src]="returnToArtistRequest.ArtistProduct?.ProductImgUrl? returnToArtistRequest.ArtistProduct?.ProductImgUrl : 'assets/images/No-Image.png'"
              style="width: 100px;" />
              <div class="d-flex flex-column ms-3">
                <h3>{{returnToArtistRequest.ArtistProduct?.Name}}</h3>
                <div>
                  @if (returnToArtistRequest.ArtistProduct?.SerialNumber) {
                    <span
                      class="badge rounded-pill text-bg-danger me-2">{{returnToArtistRequest.ArtistProduct?.SerialNumber}}
                    </span>
                  }
                  {{returnToArtistRequest.ArtistProduct?.ArtistShortDescription}}
                </div>
              </div>
            </div>
            <div class="form-group mt-4 position-relative" style="padding-right: 3rem;">
              <label for="comments" class="form-label">{{ 'galleryConsignmentProductsV2.addYourComment' | transloco }}</label>
              <textarea id="comments" name="comments" class="form-control" rows="3"
                [(ngModel)]="returnToArtistRequest.Comments" [placeholder]="'galleryConsignmentProductsV2.addRemarksForArtist' | transloco">
              </textarea>
              <div class="emoji-icon position-absolute cursor-pointer fs-5 p-2" (click)="openEmojiDialog()"
                style="top: 52%; right: 3rem; transform: translateY(-50%); ">
                (😍)
              </div>
              <div class="form-group mt-4">
                <button pButton type="button" class="w-100 p-button-outlined" (click)="returnToArtist($event)"
                [label]="'galleryConsignmentProductsV2.returnToArtist' | transloco"></button>
              </div>
            </div>
          </form>
        </p-dialog>
      }

      @if (isProductDetailDailogVisible) {
        <p-dialog [header]="'galleryConsignmentProductsV2.productDetails' | transloco" [(visible)]="isProductDetailDailogVisible" [modal]="true"
          [style]="{ 'width': '520px' }" (onHide)="closeProductInformationDailog()">
          @if (prouctDetail?.Product) {
            <div class="d-flex flex-column w-100 p-2">
              <div class="d-flex">
                <div class="custom-img-container mt-2 position-relative">
                  @if (prouctDetail) {
                    @if (prouctDetail.IsConsignedProduct && !prouctDetail.IsProductSold) {
                      <span class="badge bg-danger position-absolute start-1 top-1 my-1 ms-1"
                      >{{ 'galleryConsignmentProductsV2.consigned' | transloco }}</span>
                    }
                    @if (prouctDetail.IsProductSold && !prouctDetail.IsConsignedProduct) {
                      <span class="badge bg-danger position-absolute start-1 top-1 my-1 mx-1"
                      >{{ 'galleryConsignmentProductsV2.sold' | transloco }}</span>
                    }
                    @if (!prouctDetail.IsConsignedProduct && !prouctDetail.IsProductSold) {
                      <span class="badge bg-success position-absolute start-1 top-1 my-1 ms-1"
                      >{{ 'galleryConsignmentProductsV2.available' | transloco }}</span>
                    }
                  }
                  <div class="custom-img-container">
                    <!-- Conditionally disable image if sold -->
                    <img
                      [src]="prouctDetail.Product.ProductImgUrl ? prouctDetail.Product.ProductImgUrl : 'assets/images/No-Image.png'"
                      class="custom-img rounded-cube border" [alt]="'galleryConsignmentProductsV2.productImage' | transloco"
                      [ngClass]="{ 'disabled-img': prouctDetail.IsProductSold }">
                    </div>
                  </div>
                  <div class="d-flex flex-column ms-3">
                    <div class="text-uppercase fw-semibold d-flex align-items-center">
                      <a href="javascript:void(0);" class="text-dark fw-semibold" pTooltip="{{ prouctDetail.Product.Name }}">
                        {{ prouctDetail.Product.Name }}
                      </a>
                    </div>
                    <div>
                      @if (prouctDetail.Product.SerialNumber) {
                        <span class="badge rounded-pill text-bg-danger me-2">
                          {{ prouctDetail.Product.SerialNumber }}
                        </span>
                      }
                      {{ prouctDetail.Product.ArtistShortDescription }}
                    </div>
                  </div>
                </div>
                <div class="mt-3">
                  @if (prouctDetail.ArtistName) {
                    <div class="d-flex flex-row justify-content-between">
                      <div class="d-flex align-items-center cursor-pointer">
                        <div class="fw-semibold text-uppercase">{{ 'galleryConsignmentProductsV2.artistLabel' | transloco }} </div>
                        <div class="ms-1">{{ prouctDetail.ArtistName }}</div>
                      </div>
                    </div>
                  }
                  @if (prouctDetail.ConsignmentName) {
                    <div class="d-flex flex-row justify-content-between">
                      <div class="d-flex align-items-center cursor-pointer">
                        <div class="fw-semibold text-uppercase">{{ 'galleryConsignmentProductsV2.consignmentLabel' | transloco }} </div>
                        <div class="ms-1">{{ prouctDetail.ConsignmentName }}</div>
                      </div>
                    </div>
                  }
                  @if (prouctDetail.DispatchedDate) {
                    <div class="d-flex flex-row justify-content-between">
                      <div class="d-flex align-items-center cursor-pointer">
                        <div class="fw-semibold text-uppercase">{{ 'galleryConsignmentProductsV2.dispatchedDate' | transloco }} </div>
                        <div class="ms-1">{{ prouctDetail.DispatchedDate | date: 'dd/MM/yyyy' }}
                          @if (isToday(prouctDetail.DispatchedDate)) {
                            (today)
                          }
                          @if (!isToday(prouctDetail.DispatchedDate)) {
                            ({{
                            dispatchedDaysAgo(prouctDetail.DispatchedDate) }} days)
                          }
                        </div>
                      </div>
                    </div>
                  }
                  <div class="d-flex flex-column">
                    <div class="d-flex align-items-center cursor-pointer">
                      <div class="fw-semibold text-uppercase">{{ 'galleryConsignmentProductsV2.dateAccepted' | transloco }} </div>
                      <div class="ms-1">{{ prouctDetail.GalleryAcceptedDate | date: 'dd/MM/yyyy' }}
                        @if (prouctDetail.AcceptedBeforeXDays === 0) {
                          (today)
                        }
                        @if (prouctDetail.AcceptedBeforeXDays) {
                          ({{ prouctDetail.AcceptedBeforeXDays }}
                          days)
                        }
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <div class="d-flex align-items-center cursor-pointer">
                      <div class="fw-semibold text-uppercase">
                        @if (!prouctDetail.IsConsignedProduct && !prouctDetail.IsProductSold) {
                          {{ 'galleryConsignmentProductsV2.artistRevenue' | transloco }}
                        }
                        @if (prouctDetail.IsConsignedProduct && !prouctDetail.IsProductSold) {
                          {{ 'galleryConsignmentProductsV2.retailPrice' | transloco }}
                        }
                        @if (prouctDetail.IsProductSold) {
                          {{ 'galleryConsignmentProductsV2.soldPrice' | transloco }}
                        }
                      </div>
                      <div class="ms-1">
                        @if (!prouctDetail.IsConsignedProduct && !prouctDetail.IsProductSold) {
                          {{
                          prouctDetail.Product.ArtistRevenue | currency: 'USD' : 'symbol' : '1.2-2' }}
                        }
                        @if (prouctDetail.IsConsignedProduct && !prouctDetail.IsProductSold) {
                          {{
                          prouctDetail.RetailPrice | currency: 'USD' : 'symbol' : '1.2-2' }}
                        }
                        @if (prouctDetail.IsProductSold) {
                          {{ prouctDetail.ProductSoldPrice | currency: 'USD' :
                          'symbol' : '1.2-2' }}
                        }
                      </div>
                    </div>
                    @if (prouctDetail.SquarePosProductId || (prouctDetail.ProductSyncedOnPlatformDTO && prouctDetail.ProductSyncedOnPlatformDTO.length > 0) || prouctDetail.WixProductId) {
                      <div class="d-flex align-items-center justify-content-end"
                        >
                        <div class="d-flex flex-column align-items-center">
                          <div class="fw-semibold text-uppercase">
                            <ng-container>{{ 'galleryConsignmentProductsV2.syncedOn' | transloco }}</ng-container>
                          </div>
                          <div class="d-flex align-items-center">
                            <!-- Square -->
                            @if (prouctDetail.SquarePosProductId) {
                              <div class="cursor-pointer ms-2">
                                <img src="assets/images/square-log.png" [pTooltip]="'galleryConsignmentProductsV2.postedToSquareup' | transloco"
                                  tooltipPosition="top" alt="square-logo" style="height: 20px;">
                                </div>
                              }
                              <!-- Platform Logos shown only once -->
                              @if (prouctDetail.ProductSyncedOnPlatformDTO) {
                                @if (isWooCommerceSynced(prouctDetail.ProductSyncedOnPlatformDTO)) {
                                  <div class="cursor-pointer ms-2">
                                    <img src="assets/images/woocommerace-log.png"
                                      [pTooltip]="'galleryConsignmentProductsV2.postedToWooCommerce' | transloco" tooltipPosition="top"
                                      alt="woocommerce-logo" style="height: 20px;">
                                    </div>
                                  }
                                  @if (isShopifySynced(prouctDetail.ProductSyncedOnPlatformDTO)) {
                                    <div class="cursor-pointer ms-2">
                                      <img src="assets/images/shopify-log.png" [pTooltip]="'galleryConsignmentProductsV2.postedToShopify' | transloco"
                                        tooltipPosition="top" alt="shopify-logo" style="height: 20px;">
                                      </div>
                                    }
                                    @if (isSquareSpaceSynced(prouctDetail.ProductSyncedOnPlatformDTO)) {
                                      <div class="cursor-pointer ms-2">
                                        <img src="assets/images/squarespace.svg" [pTooltip]="'galleryConsignmentProductsV2.postedToSquarespace' | transloco"
                                          tooltipPosition="top" alt="squarespace-logo" style="height: 20px;">
                                        </div>
                                      }
                                    }
                                    <!-- Wix -->
                                    @if (prouctDetail.WixProductId) {
                                      <div class="cursor-pointer ms-2">
                                        <img src="assets/images/wix-logo.png" [pTooltip]="'galleryConsignmentProductsV2.postedToWix' | transloco"
                                          tooltipPosition="top" alt="wix-logo" style="height: 20px;">
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                          @if (authConfig.IsGallery && !prouctDetail.IsProductSold) {
                            <div class="d-flex mt-4">
                              <button pButton type="button" [label]="prouctDetail.IsProductSold ? ('galleryConsignmentProductsV2.sold' | transloco) : ('galleryConsignmentProductsV2.return' | transloco)"
                                class="w-50 p-button-danger p-button-sm p-button-outlined"
                                (click)="showReturnToArtistDialog($event, prouctDetail)">
                              </button>
                              <button pButton type="button" [label]="'galleryConsignmentProductsV2.sold' | transloco" class="w-50 p-button-success p-button-sm p-button-outlined ms-2"
                                (click)="onMarkProductAsSold($event, prouctDetail)">
                              </button>
                            </div>
                          }
                        </div>
                      }
                    </p-dialog>
                  }

                  @if (displayEmojiDialog) {
                    <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
                      (emojiClick)="addEmoji($event)">
                    </app-emoji-list>
                  }